let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1PuvZ")).then(() => parcelRequire('i6OLF'));